const OutputDate = ({ value }) => {
    if (!value) return null;
    const date = value instanceof Date ? value : new Date(value);
    return date.toLocaleDateString();
};

export default OutputDate;
